import { Box, styled } from '@mui/material';
import { memo, ReactElement } from 'react';
import { HeaderLayout } from './Header';
import { MobileFirstContainer } from '../../layouts/MobileFirstContainer';

export interface LayoutProps {
  header?: ReactElement;
  sessionStatus?: ReactElement;
  content: ReactElement;
}

export const Layout = memo(function ({ header, sessionStatus, content }: LayoutProps): ReactElement {
  return (
    <MobileFirstContainer>
      <HeaderLayout headerBar={header} sessionStatus={sessionStatus} />
      <Container>{content}</Container>
    </MobileFirstContainer>
  );
});

export const Container = styled(Box)(({ theme }) => ({
  width: '100%',
  flex: 1,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  padding: theme.spacing(1.5),
  overflowY: 'auto',
}));
